import { Play, FileText, Music, BookOpen, Film, Tv, Building2, Lightbulb } from "lucide-react";
import { Link } from "react-router-dom";
const AcervoSections = () => {
  const mainSections = [
    {
      title: "Libros Cinematográficos",
      description: "Guiones de películas filmadas y sin filmar",
      icon: Film,
      href: "/guiones",
    },
    {
      title: "Obra Producida",
      description: "Producciones realizadas y obras finalizadas por nosotros mismos",
      icon: FileText,
      href: "/obra-producida",
    },
    {
      title: "Proyectos y Series",
      description: "Proyectos televisivos y series documentales",
      icon: Tv,
      href: "/proyectos-series",
    },
    {
      title: "Argumentos",
      description: "Sinopsis y argumentos cinematográficos",
      icon: FileText,
      href: "/argumentos",
    },
    {
      title: "Cortometrajes",
      description: "Colección de cortometrajes y obras breves",
      icon: Film,
      href: "/cortometrajes",
    },
    {
      title: "Cooperativas",
      description: "Documentos y recibos de cooperativas cinematográficas",
      icon: Building2,
      href: "/cooperativas",
    },
    {
      title: "Televisión y Radio",
      description: "Programas televisivos y radiofónicos",
      icon: Tv,
      href: "/television-radio",
    },
    {
      title: "Audios de entrevistas",
      description: "Entrevistas, testimonios y grabaciones históricas",
      icon: Music,
      href: "/audios",
    },
  ];

  const specialSections = [
    {
      title: "Literatura, Teatro, Poesía y Música",
      description: "Obras de las artes escénicas y escritas",
      icon: BookOpen,
      href: "/teatro",
    },
    {
      title: "Rojo Amanecer",
      description: "Documentos y fuentes históricas para la escritura de Rojo Amanecer",
      icon: Film,
      href: "/fuentes-rojo-amanecer",
    },
  ];
  return (
    <section className="px-4 sm:px-6 lg:px-8 bg-white pt-6 md:pt-8 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto">
        {/* Sección principal */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {mainSections.map((section) => {
            const IconComponent = section.icon;

            return (
              <Link
                key={section.title}
                to={section.href}
                className="group bg-transparent rounded-2xl p-6 md:p-8 border-2 border-border hover:border-primary/40 hover:bg-card hover:shadow-lg hover:scale-105 transition-all duration-300"
              >
                <div className="flex flex-col h-full">
                  <div className="w-14 h-14 rounded-xl bg-[#8B4513] flex items-center justify-center mb-4">
                    <IconComponent size={28} className="text-white" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-playfair font-semibold text-foreground mb-3 leading-tight">
                    {section.title}
                  </h3>
                  <p className="text-foreground/70 leading-relaxed text-sm">{section.description}</p>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Sección especial separada */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {specialSections.map((section) => {
            const IconComponent = section.icon;

            return (
              <Link
                key={section.title}
                to={section.href}
                className="group bg-transparent rounded-2xl p-6 md:p-8 border-2 border-border hover:border-primary/40 hover:bg-card hover:shadow-lg hover:scale-105 transition-all duration-300"
              >
                <div className="flex flex-col h-full">
                  <div className="w-14 h-14 rounded-xl bg-[#8B4513] flex items-center justify-center mb-4">
                    <IconComponent size={28} className="text-white" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-playfair font-semibold text-foreground mb-3 leading-tight">
                    {section.title}
                  </h3>
                  <p className="text-foreground/70 leading-relaxed text-sm">{section.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default AcervoSections;
